import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { FaCalendarAlt, FaHandshake, FaTrophy, FaUsers } from "react-icons/fa";

const Achievements = () => {
  return (
    <section className="py-5 text-center" style={{ backgroundColor: "#2aa6a6" }}>
      <div className="container">
        
        {/* Section Heading */}
        <h2 className="fw-bold text-white mb-3">Our Achievements</h2>
        <p className="text-white mb-5">Numbers that speak for themselves</p>

        <div className="row g-4">

          {/* Card 1 */}
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-lg h-100 rounded-4 p-4">
              <FaCalendarAlt size={40} className="mx-auto text-info mb-3" />
              <h2 className="fw-bold text-info">16+</h2>
              <h5 className="fw-semibold mt-2">Years of Experience</h5>
              <p className="text-muted small">
                Two decades of trusted financial expertise
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-lg h-100 rounded-4 p-4">
              <FaHandshake size={40} className="mx-auto text-info mb-3" />
              <h2 className="fw-bold text-info">25+</h2>
              <h5 className="fw-semibold mt-2">Bank Partnerships</h5>
              <p className="text-muted small">
                Strong relationships with leading banks
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-lg h-100 rounded-4 p-4">
              <FaTrophy size={40} className="mx-auto text-info mb-3" />
              <h2 className="fw-bold text-info">90%</h2>
              <h5 className="fw-semibold mt-2">Success Rate</h5>
              <p className="text-muted small">
                High approval rate & satisfied customers
              </p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-lg h-100 rounded-4 p-4">
              <FaUsers size={40} className="mx-auto text-info mb-3" />
              <h2 className="fw-bold text-info">1500+</h2>
              <h5 className="fw-semibold mt-2">Happy Clients</h5>
              <p className="text-muted small">
                Families & businesses empowered financially
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Achievements;
